var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MemberSettingContainer',[_c('div',{staticClass:"d-flex mb-2"},[_c('h4',[_vm._v(" "+_vm._s(_vm.$t("myself.menu.contact-info"))+" ")])]),_c('ContactData')],1)}
var staticRenderFns = []

export { render, staticRenderFns }